/*
 * This file is part of the Sylius package.
 *
 * (c) Paweł Jędrzejewski
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
(function ($) {

    'use strict';
    $.fn.extend({
        addressBook: function () {
            var element = $(this);
            var select = element.find('.address-book-select');
            var autocomplete = element.find('div.shippable-autocomplete');

            if (autocomplete.find('input.autocomplete').is(':disabled')) {
                select.addClass('disabled');
            }

            select.dropdown({
                forceSelection: false,

                onChange: function (name, text, choice) {
                    $.each(element.find('input:not(:disabled, [name*="phoneNumber"]), select:not(:disabled)'), function (key, input) {
                        $(input).val('');
                    });

                    const address = choice.data('street') + ' ' + choice.data('number') + ', ' + choice.data('postcode') + ' ' + choice.data('city');
                    autocomplete.find('input.autocomplete').val(address);
                    const textAutocomplete = autocomplete.find('div.text');
                    if (text.length === 0) {
                        autocomplete.append("<div class='text'>" + address + "</div>");
                    } else {
                        textAutocomplete.html(address);
                    }
                    autocomplete.find('div.text').html(address);
                    autocomplete.find('.dropdown.icon').addClass('clear');

                    $.each(choice.data(), function (property, value) {
                        var field = findByName(property);
                        field.val(value).trigger('change');
                    });
                }
            });

            var parseKey = function (key) {
                return key.replace(/(_\w)/g, function (words) {
                    return words[1].toUpperCase()
                });
            };
            var findByName = function (name) {
                return element.find('[name*=' + parseKey(name) + ']');
            };
        }
    });
})(jQuery);
